import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import EventDetailPage from './Events/EventDetailPage'
import EventsPage from './Events/EventsPage'
import ExpenseDetailPage from './Expenses/ExpenseDetailPage'
import ExpensesPage from './Expenses/ExpensesPage'
import IdeaDetailPage from './Ideas/IdeaDetailPage'
import IdeasPage from './Ideas/IdeasPage'
import OverviewPage from './Overview/OverviewPage'
import TripDetailPage from './Trips/TripDetailPage'
import TripsPage from './Trips/TripsPage'
import UserDetailPage from './Users/UserDetailPage'
import UsersPage from './Users/UsersPage'

/**
 * Top-level admin route tree. Rendered inside AdminRoute (auth + role gating) and
 * AdminLayout (admin nav). Each resource has a list page and a read-only detail
 * page (`:id`); the Overview is the home.
 */
const AdminPage: React.FC = () => {
	return (
		<Routes>
			<Route index element={<Navigate to="overview" replace />} />
			<Route path="overview" element={<OverviewPage />} />
			<Route path="users" element={<UsersPage />} />
			<Route path="users/:id" element={<UserDetailPage />} />
			<Route path="trips" element={<TripsPage />} />
			<Route path="trips/:id" element={<TripDetailPage />} />
			<Route path="events" element={<EventsPage />} />
			<Route path="events/:id" element={<EventDetailPage />} />
			<Route path="ideas" element={<IdeasPage />} />
			<Route path="ideas/:id" element={<IdeaDetailPage />} />
			<Route path="expenses" element={<ExpensesPage />} />
			<Route path="expenses/:id" element={<ExpenseDetailPage />} />
			<Route path="*" element={<Navigate to="overview" replace />} />
		</Routes>
	)
}

export default AdminPage
